const HEIGHT_PROPORTION = 0.51
const WIDTH_PROPORTION = 0.84

const MATCHES = [
  /iPhone/i,
  /iPad/i,
  /iPod/i
]

// return true if is to show 4 items in slide of home of together
export const show4Items = () => {
  const ios = detectIos()
  const pixel = window.devicePixelRatio

  const heightContentDiv = ios
    ? (window.screen.availHeight * HEIGHT_PROPORTION) - pixel * 20
    : window.screen.availHeight * HEIGHT_PROPORTION

  const widthContentDiv = window.screen.availWidth * WIDTH_PROPORTION

  if ((heightContentDiv / widthContentDiv) > 0.96) {
    return true
  }

  return false
}

const detectIos = () => {
  return MATCHES.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}
